<template>
  <div ref="tabWrap" class="tab-list">
    <a-tabs
      v-model:active-key="activeTab"
      type="editable-card"
      size="small"
      :animated="false"
      :hide-add="true"
      :tab-bar-gutter="8"
      @edit="handleEdit"
    >
      <a-tab-pane
        v-for="tab in openTabs" :id="tab.fullPath" :key="tab.fullPath"
        :tab="subAppTabs[tab.fullPath] || tab.title || tab.meta?.title"
      />
    </a-tabs>
  </div>
  <!-- 右侧菜单展示 -->
  <div v-if="menuVisible" class="menu-wrap" :style="'top:' + menuPosition.top + 'px;left:' + menuPosition.left + 'px;'">
    <a-menu>
      <a-menu-item @click="handleCloseTabsOnRight">关闭右侧标签页</a-menu-item>
      <a-menu-item @click="handleCloseOtherTabs">关闭其他标签页</a-menu-item>
    </a-menu>
  </div>
</template>

<script>
export default {
  name: 'TabsNavigator'
}
</script>
<script setup>
import { computed, onBeforeMount, onMounted, reactive, ref, watch } from 'vue'
import _ from 'lodash'
import { useRouter } from 'vue-router'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { theme } from 'ant-design-vue'
// eslint-disable-next-line no-unused-vars
import { CloseOutlined } from '@ant-design/icons-vue'

const route = useRoute()

const store = useStore()
const router = useRouter()
const { token } = theme.useToken()

/**
 * 标签页计算相关
 */

const openTabs = computed(() => {
  return store.getters['system/openTabs']
})
const subAppTabs = computed(() => {
  const subAppTabs = store.getters['share/subAppTabs']
  const result = {}
  subAppTabs.map(item => {
    result[item.path] = item.title
  })
  return result
})
const activeTab = computed({
  get: () => {
    return router.currentRoute.value.fullPath
  },
  set: (value) => {
    // 获取当前
    const index = _.findIndex(openTabs.value, o => o.fullPath === value)
    const target = openTabs.value[index] || openTabs.value[openTabs.value.length - 1]
    router.replace({
      path: target.path,
      query: target.query
    })
  }
})

// eslint-disable-next-line no-unused-vars
const handleClose = function (path) {
  store.dispatch('system/closeTab', path)
}
const handleEdit = function (key) {
  store.dispatch('system/closeTab', key)
}

/**
 * 标签页菜单相关
 */

const menuVisible = ref(false)
const menuOnTab = ref(null)
const menuPosition = reactive({
  top: 0,
  left: 0
})
// eslint-disable-next-line no-unused-vars
const handleRightClick = function (e, tab) {
  e.preventDefault()
  menuVisible.value = true
  const { pageX, pageY } = e
  menuPosition.top = pageY
  menuPosition.left = pageX
  menuOnTab.value = tab
}

const handleCloseTabsOnRight = function () {
  activeTab.value = menuOnTab.value.path // 高亮到当前标签页，并关闭其他标签页 , TODO: 这里逻辑可能需要调整
  store.dispatch('system/removeBehindTab', menuOnTab.value.path)
}
const handleCloseOtherTabs = function () {
  activeTab.value = menuOnTab.value.path // 高亮到当前标签页，并关闭其他标签页
  store.dispatch('system/removeOtherTabs', menuOnTab.value.path)
}

const hideMenu = function () {
  if (menuVisible.value) {
    menuVisible.value = false
  }
}
onMounted(() => {
  window.addEventListener('click', hideMenu)
})
onBeforeMount(() => {
  window.removeEventListener('click', hideMenu)
})

/**
 *  监听设置tab标题
 */

const visibleMenuList = computed(() => {
  return store.getters['user/visibleMenuList']
})
// 从menuList中匹配
const getMatchedMenuItem = (menuList, path) => {
  for (let i = 0; i < menuList.length; i++) {
    if (menuList[i].path === path) {
      return menuList[i]
    }
    if (menuList[i].children && menuList[i].children.length > 0) {
      const result = getMatchedMenuItem(menuList[i].children, path)
      if (result) {
        return result
      }
    }
  }
  return false
}
watch(() => route.fullPath, (cur) => {
  const result = getMatchedMenuItem(visibleMenuList.value, route.path)
  store.dispatch('system/setTabTitle', { path: route.fullPath, title: result.name })
  // 根据route查找
}, {
  immediate: true
})

</script>

<style lang="less" scoped>
.menu-wrap {
    position: fixed;
    z-index: 999;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0 0 3px rgba(0,0,0,0.3);
    /deep/ .ant-menu {
      .ant-menu-item {
        line-height: 30px!important;
        height: 30px!important;
      }
    }
}

.tab-list {
  width: 100%;
  overflow: auto;
  flex-shrink: 0;
  scrollbar-width: none;
  /deep/ .mainPrefix-tabs-nav-more {
    height: 36px;
  }
  &::-webkit-scrollbar {
        display: none;
  }

  /deep/ .mainPrefix-tabs-nav {
  margin-bottom: 0!important;
  &::before {
    content: '';
    display: none;
  }
  .ant-tabs-tab-active {
    border-color: white;
  }
}
.tab-inner-wrap {
  width: fit-content;
  position: relative;
  // &:after {
  //   content: '';
  //   border-bottom: 1px solid #dedede;
  //   width: 100%;
  //   height: 1px;
  //   position: absolute;
  //   bottom: 0;
  //   z-index: 2;
  // }
    background: transparent;
    display: flex;
    flex-wrap: nowrap;
    overflow: auto;
    white-space: nowrap;
    flex-shrink: 0;
    gap: 8px;
    flex-direction: row;
    scrollbar-width: none;
    &::-webkit-scrollbar {
        display: none;
    }
    .tab-item {
      z-index: 1;
        cursor: pointer;
        color: black;
        width: fit-content;
        font-size: 14px;
        display: inline-block;
        padding: 8px 12px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        background: #f2f2f2;
        border: 1px solid #dedede;
        box-sizing: border-box;
        border-bottom: none;
        &.active {
          z-index: 3;
            background: white;
            color: v-bind('token.colorPrimary');
            border: 1px solid white;
            border-bottom: none;
        }
        .tab-item-icon {
            cursor: pointer;
            font-size: 12px;
        }
    }
}
}
</style>
